import defaultLogo from '../assets/image/isafe-enterprises-logo.svg';

// Build-time whitelabel branding (VITE_BRAND_* — see vite.config.mjs).
// Unset values fall back to the bundled ISAFE name and logo.
export const BRAND_NAME = import.meta.env.VITE_BRAND_NAME || 'ISAFE DC4';
export const BRAND_LOGO = import.meta.env.VITE_BRAND_LOGO || defaultLogo;
